import {
  Button,
  Header,
  Icon,
  LoadingSpinner,
  WrapKontomatik,
  Popup,
  Base64File,
  Base64FileInput,
} from '../../components/Generic'
import { observer } from 'mobx-react'
import React, { useContext, useEffect, useState } from 'react'
import { StoreContext } from '../../components/App'
import {
  ButtonImgWrap,
  ButtonText,
  FileDeselect,
  FileError,
  FileInfo,
  FileName,
  FileUpload,
  FileWarning,
  HorizontalBorder,
  PopupTutorial,
  TabSwitcher,
  UnderlinedBold,
  UnderlinedButton,
  UploadDefault,
  UploadIcon,
  UploadParagraph,
  UploadTitle,
} from '../../styles/generic.styles'
import {
  CenteredContent,
  ContentContainerBottomFixedHorizontal,
  MarginOnly,
  MarginedWithHeight,
  MobileSpacerForContentContainerBottomFixed,
} from '../../styles/layout.styles'

import tutorial_1 from '../../assets/pko-tutorial/1_login.png'
import tutorial_1_pl from '../../assets/pko-tutorial/1_login_pl.png'
import tutorial_2 from '../../assets/pko-tutorial/2_select.png'
import tutorial_2_pl from '../../assets/pko-tutorial/2_select_pl.png'
import tutorial_3 from '../../assets/pko-tutorial/3_click.png'
import tutorial_3_pl from '../../assets/pko-tutorial/3_click_pl.png'
import tutorial_4 from '../../assets/pko-tutorial/4_scroll.png'
import tutorial_4_pl from '../../assets/pko-tutorial/4_scroll_pl.png'
import tutorial_5 from '../../assets/pko-tutorial/5_download.png'
import tutorial_5_pl from '../../assets/pko-tutorial/5_download_pl.png'

import tutorial_mobile_1 from '../../assets/pko-tutorial/1_login_mobile.png'
import tutorial_mobile_1_pl from '../../assets/pko-tutorial/1_login_mobile_pl.png'
import tutorial_mobile_2 from '../../assets/pko-tutorial/2_select_mobile.png'
import tutorial_mobile_2_pl from '../../assets/pko-tutorial/2_select_mobile_pl.png'
import tutorial_mobile_3 from '../../assets/pko-tutorial/3_provide_mobile.png'
import tutorial_mobile_3_pl from '../../assets/pko-tutorial/3_provide_mobile_pl.png'
import tutorial_mobile_4 from '../../assets/pko-tutorial/4_select_mobile.png'
import tutorial_mobile_4_pl from '../../assets/pko-tutorial/4_select_mobile_pl.png'
import tutorial_mobile_5 from '../../assets/pko-tutorial/5_click_mobile.png'
import tutorial_mobile_5_pl from '../../assets/pko-tutorial/5_click_mobile_pl.png'
import tutorial_mobile_6 from '../../assets/pko-tutorial/6_scroll_mobile.png'
import tutorial_mobile_6_pl from '../../assets/pko-tutorial/6_scroll_mobile_pl.png'
import tutorial_mobile_7 from '../../assets/pko-tutorial/7_download_mobile.png'
import tutorial_mobile_7_pl from '../../assets/pko-tutorial/7_download_mobile_pl.png'

import { axiosInstance } from '../../methods/axiosConfig'
import { devLog } from '../../methods/devLog'
import { forceRedirect } from '../../methods/forceRedirect'

export const AddressUploadPageKontomatik = observer(() => {
  const store = useContext(StoreContext)

  const { kontomatikSelectedBank } = store.AppState

  const { theme } = store.InterfaceState
  const { currentPageIndex } = store.ScenarioState

  const { addressUploadPageKontomatik: trans } =
    store.TranslationsState.translations
  const { language } = store.TranslationsState

  const [fileSelected, setFileSelected] = useState<Base64File>()
  const [fileInputKey, setFileInputKey] = useState(Date.now())
  const [fileError, setFileError] = useState('')
  const [loading, setLoading] = useState(false)

  const [tutorialPopupVisible, setTutorialPopupVisible] = useState(false)
  const [tutorialPopupTabMobile, setTutorialPopupTabMobile] = useState(false)

  const resetFileInput = () => {
    setFileInputKey(Date.now())
    setFileSelected(undefined)
    setFileError('')
  }

  const handleBack = () => {
    store.ScenarioState.setCurrentPage(currentPageIndex - 2)
  }

  const handleProceed = async () => {
    setLoading(true)
    await handleFile()

    const apiUrl = process.env.WEB_API_URL
    forceRedirect(`${apiUrl}/kontomatik/complete`)
  }

  const getFiles = async (file) => {
    setFileSelected(file)
  }

  const handleFile = async () => {
    try {
      const apiUrl = process.env.WEB_API_URL

      await axiosInstance.post(
        `${apiUrl}/kontomatik/bank-statement`,
        {
          pdfStatement: fileSelected.base64.slice(28),
        },
        {
          withCredentials: true,
        }
      )
    } catch (e) {
      devLog(e)
    }
  }

  useEffect(() => {
    if (fileSelected?.base64) {
      if (fileSelected.type !== 'application/pdf') {
        setFileError(
          kontomatikSelectedBank === 'pko'
            ? trans.pko.selectPDF
            : trans.other.selectPDF
        )
      } else {
        setFileError('')
      }
    } else {
      resetFileInput()
    }
  }, [fileSelected, fileSelected?.base64])

  useEffect(() => {
    if (!store.AppState.shouldUploadBankStatement) {
      store.ScenarioState.setCurrentPage(currentPageIndex + 1)
    }
  }, [])

  const isTouchScrollDisabled = () => {
    if (tutorialPopupVisible) {
      return 'none'
    } else {
      return 'auto'
    }
  }

  const getHeaderText = () => {
    if (kontomatikSelectedBank === 'pko') {
      return trans.pko.header
    } else if (kontomatikSelectedBank === 'other') {
      return trans.other.header
    } else {
      return trans.header
    }
  }

  return (
    <WrapKontomatik
      {...theme.wrapKontomatik}
      width="560px"
      paddingMobile="20px"
      marginMobile="0"
      touchAction={isTouchScrollDisabled()}
    >
      {loading ? (
        <>
          <MarginedWithHeight margin="0 0 15px" height="0">
            <Header
              {...theme.header}
              fontFamily={theme.globals.fontFamilyHeadline}
            >
              {trans.verifying}
            </Header>
          </MarginedWithHeight>
          <LoadingSpinner
            width="68px"
            padding="100px 0"
            {...theme.loadingSpinner}
          />
        </>
      ) : (
        <>
          <Header
            {...theme.header}
            fontFamily={theme.globals.fontFamilyHeadline}
          >
            {getHeaderText()}
          </Header>

          <MarginOnly margin="20px 0 30px 0">
            {kontomatikSelectedBank === 'pko' ? (
              <>
                <MarginOnly margin="20px 0 0 0">
                  <UploadParagraph>{trans.pko.confirmation}</UploadParagraph>
                </MarginOnly>

                <CenteredContent margin="30px 0">
                  <UnderlinedButton
                    onClick={() => setTutorialPopupVisible(true)}
                  >
                    {trans.pko.whereToFindStatements}
                  </UnderlinedButton>
                </CenteredContent>
              </>
            ) : (
              <>
                <UploadParagraph>{trans.description}</UploadParagraph>
                <UploadParagraph>{trans.confirmation}</UploadParagraph>
              </>
            )}
          </MarginOnly>

          {!fileSelected && (
            <FileWarning>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="25"
                viewBox="0 0 28 25"
                fill="none"
              >
                <path
                  d="M14.0003 10.2827C14.8109 10.2827 15.4512 10.9704 15.3935 11.7789L15.0716 16.2852C15.0315 16.8472 14.5638 17.2827 14.0003 17.2827C13.4369 17.2827 12.9692 16.8472 12.9291 16.2852L12.6072 11.7789C12.5495 10.9704 13.1898 10.2827 14.0003 10.2827Z"
                  fill="white"
                />
                <path
                  d="M14.0003 18.2827C13.4481 18.2827 13.0003 18.7304 13.0003 19.2827C13.0003 19.835 13.4481 20.2827 14.0003 20.2827C14.5526 20.2827 15.0003 19.835 15.0003 19.2827C15.0003 18.7304 14.5526 18.2827 14.0003 18.2827Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.4322 4.99234C14.2393 4.66158 13.7614 4.66158 13.5685 4.99233L3.92105 21.5307C3.72661 21.8641 3.96704 22.2827 4.35294 22.2827H23.6478C24.0336 22.2827 24.2741 21.8641 24.0796 21.5307L14.4322 4.99234Z"
                  fill="white"
                />
                <path
                  d="M14 10.2832C14.8106 10.2832 15.4509 10.9709 15.3931 11.7794L15.0712 16.2857C15.0311 16.8478 14.5634 17.2832 14 17.2832C13.4366 17.2832 12.9689 16.8478 12.9288 16.2857L12.6069 11.7794C12.5491 10.9709 13.1894 10.2832 14 10.2832Z"
                  fill="#FF8F8F"
                />
                <path
                  d="M14 18.2832C13.4477 18.2832 13 18.7309 13 19.2832C13 19.8355 13.4477 20.2832 14 20.2832C14.5523 20.2832 15 19.8355 15 19.2832C15 18.7309 14.5523 18.2832 14 18.2832Z"
                  fill="#FF8F8F"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.7276 3.24473C14.9558 1.92172 13.0442 1.92172 12.2724 3.24473L1.75452 21.2755C0.97675 22.6088 1.93849 24.2832 3.48207 24.2832H24.5179C26.0615 24.2832 27.0233 22.6088 26.2455 21.2755L15.7276 3.24473ZM14.4319 4.99286C14.239 4.6621 13.7611 4.6621 13.5681 4.99285L3.9207 21.5313C3.72626 21.8646 3.9667 22.2832 4.35259 22.2832H23.6474C24.0333 22.2832 24.2737 21.8646 24.0793 21.5313L14.4319 4.99286Z"
                  fill="#FF8F8F"
                />
              </svg>
              <span>{trans.bankStatementContains}</span>
            </FileWarning>
          )}

          {!tutorialPopupVisible ? (
            <FileUpload isFile={!!fileSelected}>
              <Base64FileInput
                key={fileInputKey}
                multiple={false}
                onChange={getFiles}
              />
              {fileSelected ? (
                <FileInfo>
                  <FileName>{fileSelected.name}</FileName>
                  <FileDeselect onClick={() => resetFileInput()}>
                    <svg
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.74976 18.2832C14.7203 18.2832 18.7498 14.2538 18.7498 9.2832C18.7498 4.31264 14.7203 0.283203 9.74976 0.283203C4.77919 0.283203 0.749756 4.31264 0.749756 9.2832C0.749756 14.2538 4.77919 18.2832 9.74976 18.2832Z"
                        fill="#2A0062"
                      />
                      <path
                        d="M6.74976 6.2832L9.74976 9.2832L6.74976 12.2832"
                        stroke="white"
                        strokeWidth="2"
                      />
                      <path
                        d="M12.7498 12.2832L9.74976 9.2832L12.7498 6.2832"
                        stroke="white"
                        strokeWidth="2"
                      />
                    </svg>
                  </FileDeselect>
                </FileInfo>
              ) : (
                <UploadDefault>
                  <UploadIcon>
                    <svg width="50" height="51" viewBox="0 0 50 51" fill="none">
                      <circle cx="25" cy="25.2832" r="25" fill="#EDEEEF" />
                      <path
                        d="M25.5 29.0332V37.6582M25.5 29.0332L22.5 32.0332M25.5 29.0332L28.5 32.0332"
                        stroke="#2C3E4F"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                      <path
                        d="M30.1363 15.7863L30.4488 16.3651L31.104 16.3074L31.26 16.2937C31.3624 16.2869 31.4634 16.2832 31.5625 16.2832C33.9443 16.2832 35.875 18.2135 35.875 20.5957C35.875 22.9779 33.9443 24.9082 31.5625 24.9082H31.5357H31.5088H31.4819H31.4551H31.4282H31.4014H31.3745H31.3476H31.3207H31.2938H31.2669H31.2401H31.2132H31.1863H31.1593H31.1324H31.1055H31.0786H31.0517H31.0247H30.9978H30.9709H30.9439H30.917H30.89H30.8631H30.8361H30.8092H30.7822H30.7553H30.7283H30.7013H30.6743H30.6473H30.6204H30.5934H30.5664H30.5394H30.5124H30.4854H30.4584H30.4314H30.4044H30.3773H30.3503H30.3233H30.2963H30.2692H30.2422H30.2152H30.1881H30.1611H30.134H30.107H30.0799H30.0529H30.0258H29.9987H29.9717H29.9446H29.9175H29.8905H29.8634H29.8363H29.8092H29.7821H29.7551H29.728H29.7009H29.6738H29.6467H29.6196H29.5925H29.5654H29.5383H29.5111H29.484H29.4569H29.4298H29.4027H29.3755H29.3484H29.3213H29.2942H29.267H29.2399H29.2127H29.1856H29.1585H29.1313H29.1042H29.077H29.0499H29.0227H28.9955H28.9684H28.9412H28.9141H28.8869H28.8597H28.8326H28.8054H28.7782H28.7511H28.7239H28.6967H28.6695H28.6423H28.6152H28.588H28.5608H28.5336H28.5064H28.4792H28.452H28.4248H28.3976H28.3704H28.3432H28.316H28.2888H28.2616H28.2344H28.2072H28.18H28.1528H28.1256H28.0984H28.0712H28.044H28.0168H27.9896H27.9623H27.9351H27.9079H27.8807H27.8535H27.8262H27.799H27.7718H27.7446H27.7174H27.6901H27.6629H27.6357H27.6084H27.5812H27.554H27.5268H27.4995H27.4723H27.4451H27.4178H27.3906H27.3634H27.3361H27.3089H27.2817H27.2544H27.2272H27.2H27.1727H27.1455H27.1183H27.091H27.0638H27.0366H27.0093H26.9821H26.9549H26.9276H26.9004H26.8731H26.8459H26.8187H26.7914H26.7642H26.737H26.7097H26.6825H26.6553H26.628H26.6008H26.5736H26.5463H26.5191H26.4918H26.4646H26.4374H26.4102H26.3829H26.3557H26.3285H26.3012H26.274H26.2468H26.2195H26.1923H26.1651H26.1379H26.1106H26.0834H26.0562H26.029H26.0017H25.9745H25.9473H25.9201H25.8929H25.8656H25.8384H25.8112H25.784H25.7568H25.7296H25.7023H25.6751H25.6479H25.6207H25.5935H25.5663H25.5391H25.5119H25.4847H25.4575H25.4303H25.4031H25.3759H25.3487H25.3215H25.2943H25.2671H25.2399H25.2128H25.1856H25.1584H25.1312H25.104H25.0768H25.0497H25.0225H24.9953H24.9681H24.941H24.9138H24.8866H24.8595H24.8323H24.8052H24.778H24.7508H24.7237H24.6965H24.6694H24.6422H24.6151H24.588H24.5608H24.5337H24.5065H24.4794H24.4523H24.4251H24.398H24.3709H24.3438H24.3167H24.2895H24.2624H24.2353H24.2082H24.1811H24.154H24.1269H24.0998H24.0727H24.0456H24.0185H23.9914H23.9643H23.9373H23.9102H23.8831H23.856H23.829H23.8019H23.7748H23.7478H23.7207H23.6937H23.6666H23.6395H23.6125H23.5855H23.5584H23.5314H23.5044H23.4773H23.4503H23.4233H23.3963H23.3692H23.3422H23.3152H23.2882H23.2612H23.2342H23.2072H23.1802H23.1532H23.1262H23.0993H23.0723H23.0453H23.0183H22.9914H22.9644H22.9375H22.9105H22.8836H22.8566H22.8297H22.8027H22.7758H22.7489H22.7219H22.695H22.6681H22.6412H22.6143H22.5874H22.5605H22.5336H22.5067H22.4798H22.4529H22.426H22.3991H22.3723H22.3454H22.3185H22.2917H22.2648H22.238H22.2111H22.1843H22.1575H22.1306H22.1038H22.077H22.0502H22.0233H21.9965H21.9697H21.9429H21.9161H21.8894H21.8626H21.8358H21.809H21.7823H21.7555H21.7287H21.702H21.6752H21.6485H21.6217H21.595H21.5683H21.5416H21.5148H21.4881H21.4614H21.4347H21.408H21.3813H21.3546H21.328H21.3013H21.2746H21.248H21.2213H21.1946H21.168H21.1414H21.1147H21.0881H21.0615H21.0348H21.0082H20.9816H20.955H20.9284H20.9018H20.8752H20.8487H20.8221H20.7955H20.769H20.7424H20.7159H20.6893H20.6628H20.6363H20.6097H20.5832H20.5567H20.5302H20.5037H20.4772H20.4507H20.4242H20.3978H20.3713H20.3448H20.3184H20.2919H20.2655H20.239H20.2126H20.1862H20.1598H20.1334H20.107H20.0806H20.0542H20.0278H20.0014H19.975H19.9487H19.9223H19.896H19.8696H19.8433H19.817H19.7906H19.7643H19.738H19.7117H19.6854H19.6591H19.6329H19.6066H19.5803H19.5541H19.5278H19.5016H19.4753H19.4491H19.4229H19.3967H19.3705H19.3443H19.3181H19.2919H19.2657H19.2395H19.2134H19.1872H19.1611H19.1349H19.1088H19.0827H19.0566H19.0304H19.0043H18.9783H18.9522H18.9261H18.9H18.874H18.8479H18.8219H18.7958H18.7698H18.7438H18.7178H18.6917H18.6657H18.6398H18.6138H18.5878H18.5618H18.5359H18.5099H18.484H18.4581H18.4321H18.4062H18.3803H18.3544H18.3285H18.3026H18.2768H18.2509H18.225H18.1992H18.1733H18.1475H18.1217H18.0959H18.0701H18.0443H18.0185H17.9927H17.9669H17.9412H17.9154H17.8897H17.8639H17.8382H17.8125C16.1211 24.9082 14.75 23.5371 14.75 21.8457C14.75 20.219 16.0194 18.887 17.6208 18.7886L18.4455 18.738L18.5513 17.9186C18.9436 14.8806 21.5422 12.5332 24.6875 12.5332C27.0411 12.5332 29.0893 13.847 30.1363 15.7863Z"
                        fill="white"
                        stroke="#2C3E4F"
                        strokeWidth="2"
                      />
                    </svg>
                  </UploadIcon>
                  <UploadTitle>
                    <span>
                      {trans.dragAndDrop}
                      <UnderlinedBold fontFamily={theme.globals.fontFamilyBold}>
                        {trans.chooseFile}
                      </UnderlinedBold>
                    </span>
                  </UploadTitle>
                </UploadDefault>
              )}
            </FileUpload>
          ) : (
            <> </>
          )}

          {fileError && <FileError>{fileError}</FileError>}

          <ContentContainerBottomFixedHorizontal mobileGap="16px">
            <Button
              onClick={() => handleBack()}
              {...theme.button}
              bgColor="transparent"
              border="1px solid #DCDBE2"
              color="#34353A"
              width="164px"
              paddingMobile="14px 40px"
            >
              <ButtonImgWrap>
                <Icon size="18px" type="arrow-left" />
              </ButtonImgWrap>
              <ButtonText>{trans.back}</ButtonText>
            </Button>

            <Button
              onClick={() => handleProceed()}
              {...theme.button}
              width="164px"
              paddingMobile="14px 40px"
              disabled={!fileSelected || !!fileError}
              styles={{
                cursor:
                  !fileSelected || !!fileError ? 'not-allowed' : 'pointer',
              }}
            >
              <ButtonImgWrap>
                <Icon size="18px" type="checkmark" />
              </ButtonImgWrap>
              <ButtonText>{trans.proceed}</ButtonText>
            </Button>
          </ContentContainerBottomFixedHorizontal>
          <MobileSpacerForContentContainerBottomFixed />
        </>
      )}

      <Popup
        visibility={tutorialPopupVisible}
        handleVisibility={setTutorialPopupVisible}
        {...theme.popup}
      >
        <h1>{trans.pko.whereToFindStatements}</h1>
        <TabSwitcher {...theme.tabSwitcher}>
          <button
            onClick={() => setTutorialPopupTabMobile(false)}
            className={!tutorialPopupTabMobile ? 'active' : ''}
          >
            {trans.pko.tutorial.desktop.version}
          </button>
          <button
            onClick={() => setTutorialPopupTabMobile(true)}
            className={tutorialPopupTabMobile ? 'active' : ''}
          >
            {trans.pko.tutorial.mobile.version}
          </button>
        </TabSwitcher>
        {!tutorialPopupTabMobile ? (
          <PopupTutorial key="desktop">
            <div>{trans.pko.tutorial.desktop.step1}</div>
            <img
              src={language === 'pl' ? tutorial_1_pl : tutorial_1}
              alt="PKO login"
            />
            <HorizontalBorder margin="30px 0" />

            <div>{trans.pko.tutorial.desktop.step2}</div>
            <img
              src={language === 'pl' ? tutorial_2_pl : tutorial_2}
              alt="PKO login"
            />
            <HorizontalBorder margin="30px 0" />

            <div>{trans.pko.tutorial.desktop.step3}</div>
            <img
              src={language === 'pl' ? tutorial_3_pl : tutorial_3}
              alt="PKO login"
            />
            <HorizontalBorder margin="30px 0" />

            <div>{trans.pko.tutorial.desktop.step4}</div>
            <img
              src={language === 'pl' ? tutorial_4_pl : tutorial_4}
              alt="PKO login"
            />
            <HorizontalBorder margin="30px 0" />

            <div>{trans.pko.tutorial.desktop.step5}</div>
            <img
              src={language === 'pl' ? tutorial_5_pl : tutorial_5}
              alt="PKO login"
            />
          </PopupTutorial>
        ) : (
          <PopupTutorial key="mobile">
            <div>{trans.pko.tutorial.mobile.step1}</div>
            <img
              src={language === 'pl' ? tutorial_mobile_1_pl : tutorial_mobile_1}
              alt="PKO login"
            />
            <HorizontalBorder margin="30px 0" />

            <div>{trans.pko.tutorial.mobile.step2}</div>
            <img
              src={language === 'pl' ? tutorial_mobile_2_pl : tutorial_mobile_2}
              alt="PKO login"
            />
            <HorizontalBorder margin="30px 0" />

            <div>{trans.pko.tutorial.mobile.step3}</div>
            <img
              src={language === 'pl' ? tutorial_mobile_3_pl : tutorial_mobile_3}
              alt="PKO login"
            />
            <HorizontalBorder margin="30px 0" />

            <div>{trans.pko.tutorial.mobile.step4}</div>
            <img
              src={language === 'pl' ? tutorial_mobile_4_pl : tutorial_mobile_4}
              alt="PKO login"
            />
            <HorizontalBorder margin="30px 0" />

            <div>{trans.pko.tutorial.mobile.step5}</div>
            <img
              src={language === 'pl' ? tutorial_mobile_5_pl : tutorial_mobile_5}
              alt="PKO login"
            />
            <HorizontalBorder margin="30px 0" />

            <div>{trans.pko.tutorial.mobile.step6}</div>
            <img
              src={language === 'pl' ? tutorial_mobile_6_pl : tutorial_mobile_6}
              alt="PKO login"
            />
            <HorizontalBorder margin="30px 0" />

            <div>{trans.pko.tutorial.mobile.step7}</div>
            <img
              src={language === 'pl' ? tutorial_mobile_7_pl : tutorial_mobile_7}
              alt="PKO login"
            />
          </PopupTutorial>
        )}
      </Popup>
    </WrapKontomatik>
  )
})
